import MuiSvgIcon, { type SvgIconProps } from "@mui/material/SvgIcon";

export type { SvgIconProps };

export function SvgIcon(props: SvgIconProps) {
  return <MuiSvgIcon {...props} />;
}
